import { Injectable } from '@angular/core';
import { ChecklistEntity } from '../../domain/entities/checklist.entity';
import { ChecklistStepEntity } from '../../domain/entities/checklist-step.entity';
import { ChecklistListItemEntity } from '../../domain/entities/checklist-list-item.entity';
import { ChecklistResponseDto } from '../dtos/checklist-response.dto';
import { ChecklistStepResponseDto } from '../dtos/checklist-step-response.dto';
import { ChecklistListItemResponseDto } from '../dtos/checklist-list-item-response.dto';

@Injectable({ providedIn: 'root' })
export class ChecklistMapper {
  public toDomain(dto: ChecklistResponseDto): ChecklistEntity {
    const entity = new ChecklistEntity();
    entity.id = dto.id;
    entity.displayOnInvestigations = dto.displayOnCases;
    entity.steps = this.toStepDomainArray(dto.steps);
    return entity;
  }

  public toStepDomain(dto: ChecklistStepResponseDto): ChecklistStepEntity {
    const entity = new ChecklistStepEntity();
    entity.id = dto.id;
    entity.description = dto.description;
    entity.displayOrder = dto.displayOrder;
    return entity;
  }

  public toStepDomainArray(dtos: ChecklistStepResponseDto[]): ChecklistStepEntity[] {
    return dtos.map((dto) => this.toStepDomain(dto));
  }

  public toListItemDomain(dto: ChecklistListItemResponseDto): ChecklistListItemEntity {
    const entity = new ChecklistListItemEntity();
    entity.id = dto.id;
    entity.investigationTypeId = dto.investigationTypeId;
    entity.investigationTypeName = dto.investigationTypeName;
    entity.stepCount = dto.stepCount;
    entity.displayOnCases = dto.displayOnCases;
    return entity;
  }

  public toListItemDomainArray(dtos: ChecklistListItemResponseDto[]): ChecklistListItemEntity[] {
    return dtos.map((dto) => this.toListItemDomain(dto));
  }
}
